import { Field, useFormikContext } from 'formik';
import Address from 'src/components/util/Address';
import FieldHelperText from 'src/components/util/FieldHelperText';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import ADDRESS_FIELD_PROPS from 'src/data/propertyInfo/addressFieldNames';

export default function RealPropertyInfo({ title }) {
  const form = useFormikContext();

  return (
    <Section title={`${title} Information`}>
      <FieldHelperText>
        Enter the serial number without colons. For example, enter 999999999 instead of 99:999:9999.
      </FieldHelperText>
      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label="Real Property Serial Number"
        name="info.serialNumber"
        onChange={(e) => {
          form.setFieldValue('info.serialNumber', e.target.value);
        }}
        type="number"
      />
      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label="Type of Property (e.g., commercial, primary residential, etc.)"
        name="info.type"
        onChange={(e) => {
          form.setFieldValue('info.type', e.target.value);
        }}
        type="text"
      />
      <Subheader>Location or Address of Subject Property</Subheader>
      <Address fieldNames={ADDRESS_FIELD_PROPS} />
    </Section>
  );
}
